<template>
  <div class="post-card" :class="{ 'is-large': isLarge }" :data-type="type">
    <div
      class="post-card-cover"
      :class="{ 'is-square-cover': isSquareCover }"
      :style="`background-image: url('${post.image}')`"
    ></div>
    <div class="post-card-content">
      <template v-if="[0, 1, 5].includes(type)">
        <div class="post-card-author">
          <small>Por </small><strong>{{ post.author }}</strong>
        </div>
        <div class="post-card-date">
          <calendar-icon width="15" class="icon" />
          <span> {{ post.posted_at }}</span>
        </div>
      </template>
      <template v-else-if="type === 6">
        <span class="post-card-event-tag">Evento Online</span>
      </template>
      <h4>
        <router-link :to="to">{{ post.title }}</router-link>
      </h4>
      <template v-if="type === 6">
        <div class="post-card-event-datetime">
          <span class="item">
            <calendar-icon width="15" />
            {{ post.event_date }}
          </span>
          <span class="item">
            <clock-icon width="15" />
            {{ post.event_hour }}
          </span>
        </div>
      </template>
      <div class="post-card-text" v-if="isLarge">{{ post.text }}</div>
      <router-link
        v-if="buttonText || buttonTextOfType"
        class="button button-orange is-outlined is-small"
        :to="to"
      >
        <template v-if="buttonText">{{ buttonText }}</template>
        <template v-else>{{ buttonTextOfType }}</template>
      </router-link>
    </div>
  </div>
</template>

<script>
import CalendarIcon from "@/components/Svg/CalendarIcon";
import ClockIcon from "@/components/Svg/ClockIcon";

export default {
  components: { CalendarIcon, ClockIcon },

  props: {
    post: Object,
    buttonText: {
      type: String,
    },
    hasButton: {
      type: Boolean,
      default: true,
    },
    isLarge: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      defaut: "post",
    },

    isSquareCover: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    to() {
      const name = {
        0: "blog_detail",
        1: "blog_detail",
        2: "blog_detail",
        3: "blog_detail",
        4: "blog_detail",
        5: "podcast_detail",
        6: "event_detail",
      }[this.type];
      console.log("post", this.type);
      return {
        name,
        params: {
          slug: this.post.slug,
          type: this.type === 1 ? "video" : "post",
        },
      };
    },

    buttonTextOfType() {
      return {
        0: "LER MAIS",
        1: "ASSISTA",
        2: "LER MAIS",
        3: "LER MAIS",
        4: "LER MAIS",
        5: "OUÇA MAIS",
        6: "VER MAIS",
      }[this.type];
    },
  },
};
</script>

<style>
</style>
